<template>
  <add-product-to-card-modal
    ref="quantityModal"
    :add-to-card-callback="addToCart"
  />
</template>

<script>
import store from "@/store";
import AddProductToCardModal from "@/components/partial/AddProductToCardModal";

export default {
  store,
  name: "SubscriptionCartBtn",
  components: { AddProductToCardModal },
  props: {
    subscriptionId: [String, Number],
    directToCard: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    addToCart(quantity) {
      let data = {
        subscription_id: this.subscriptionId,
        quantity: quantity
      };

      store
        .dispatch("cart/addSubscription", data)
        .then(() => {
          this.$refs.quantityModal.success(this.directToCard);
        })
        .catch(() => {
          this.$refs.quantityModal.failed();
        });
    }
  }
};
</script>
